import {
    APP_SET_LOGIN_STATE,
    APP_SET_WINDOW_SIZE,
} from "../actions/types";

const initialState = {
    loginState: undefined,
    windowSize: { width: window.innerWidth, height: window.innerHeight }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case APP_SET_LOGIN_STATE:
            return { ...state, loginState: action.data };
        case APP_SET_WINDOW_SIZE:
            return { ...state, windowSize: action.data };
    
        default:
            return state
    }
};
